/** @module csi/widget/_svg/Link */
define([
	"dijit/form/Button",
	"./_Plugin",
	"./PluginFactory",
	"dojo/text!./resources/Button.html"
], function(Button,_Plugin,PluginFactory, template) {

	return PluginFactory.declare([Button, _Plugin], {
		templateString: template,
		"class": 'csi-button-toggle',
		materialIcon: "link",
		pluginName: "link",
		title: "CanvasLink",

		/**
		 * Enable if shape is in text edit mode, and is not placeholder
		 * @param {Shape[]} shapes
		 * @return {boolean}
		 */
		enablePlugin: function(shapes) {
			return this.inherited(arguments) && shapes && shapes.length === 1 && this.editor.isEditTextCanvasMode();
		},

		/**
		 * Add link to selected text content
		 */
		onClick: function() {
			this.editor.setTextStyle(this.pluginName, this.pluginName);
		}
	});
});
